import React from 'react';
import '../../content/css/BackButton.css';
import { Glyphicon } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';

export const BackButton = (props) => (
    <LinkContainer to={props.to}>
        <button type="button" className="btn btn-labeled btn-default btn-back">
            <span className="btn-label"><Glyphicon glyph="chevron-left" /></span>Back
        </button>
    </LinkContainer>
);



// WEBPACK FOOTER //
// ./src/components/Home/BackButton.js